<template>
  <div class="book-view">
    <div class="book-div" v-if="bookType === 12" v-loading="loading">
      <div class="book-header">
        <i v-for="(item, index) in menuList" :key="index" :class="item.icon" @click="item.click(index)" :title="item.title"></i>
      </div>
      <div class="book-content" v-loading="loading2" element-loading-background="rgba(250, 250, 250, 1)">
        <div class="middle">
          <div class="jd">
            <div class="bfb" :style="{ width: width}"></div>
          </div>
          <div class="prev">
            <i class="el-icon-arrow-left" @click="prev"></i>
          </div>
          <div class="area" id="area"></div>
          <div class="next">
            <i class="el-icon-arrow-right" @click="next"></i>
          </div>
        </div>
      </div>
      <div class="modal-div" v-show="dialogVisible" @click.stop="closeModal">
        <div class="catalog-view" v-show="modalType === 0" @click.stop>
          <div class="modal-header">
            <span>
              目录
            </span>
            <i class="el-icon-close" @click="closeModal"></i>
          </div>
          <div class="catalog-tree">
            <el-tree
              :data="tocList"
              :props="defaultProps"
              @node-click="nodeClick">
            </el-tree>
          </div>
        </div>
        <div class="setting-view"  v-show="modalType === 1" @click.stop>
          <div class="modal-header">
            <span>
              设置
            </span>
            <i class="el-icon-close" @click="closeModal"></i>
          </div>
          <div class="setting-content">
            <p>文字大小</p>
            <el-input-number v-model="fontSize" @change="handleChange" :min="10" :max="50" label="描述文字"></el-input-number>
          </div>
        </div>
      </div>
    </div>
    <iframe class="pdfDiv" :src="pdfUrl" width="100%" height="100%" v-else-if="bookType === 11">
    </iframe>
    <div class="mp3" v-else-if="bookType === 13" style="text-align: center">
      <audio controls>
        <source :src="audiomp3" type="audio/mpeg">
        您的浏览器不支持 audio 元素。
      </audio>
    </div>
    <div class="mp4" v-else-if="bookType === 14" style="text-align: center">
      <video width="600" height="500" controls>
        <source :src="videomp4" type="video/mp4">
        您的浏览器不支持 HTML5 video 标签。
      </video>
    </div>
  </div>
</template>
<script>
import Axios from 'axios'
export default {
  name: '',
  data () {
    return {
      book: '',
      aa: '',
      bfb: 0,
      rendition: null,
      dialogVisible: false,
      loading: true,
      loading2: false,
      width: 0,
      modalType: '',
      fontSize: 14,
      bookType: true,
      pdfUrl: '',
      menuList: [{
        title: '目录',
        icon: 'el-icon-tickets',
        click: this.showModal
      }, {
        title: '设置',
        icon: 'el-icon-setting',
        click: this.showModal
      }],
      tocList: [],
      defaultProps: {
        children: 'subitems',
        label: 'label'
      },
      bookObj: {},
      locationCfi: '',
      rate: 0,
      showMp3: false,
      audiomp3: '',
      videomp4: ''
    }
  },
  methods: {
    next () {
      this.book.nextPage()
    },
    prev () {
      this.book.prevPage()
    },
    showModal (index) { // 显示弹出框
      this.dialogVisible = !this.dialogVisible
      this.modalType = index
    },
    closeModal () { // 关闭弹出框
      this.dialogVisible = !this.dialogVisible
      this.modalType = ''
    },
    nodeClick (obj, node, e) {
      // console.log(obj, node, e)
      // if (this.bfb > 10) {
      //   alert('aa')
      //   return false
      // }
      const cfi = obj.cfi
      this.book.goto(cfi)
    },
    getPages (obj) { // 获取分页
      const self = this
      self.book.generatePagination().then(function (toc) {
        self.loading = false
        self.aa = self.book.currentChapter.cfi
      })
    },
    getToc () { // 获取目录
      const self = this
      this.book.getToc().then(function (toc) {
        self.tocList = toc
      })
    },
    getBook (bookUrl) { // 获取图书
      this.book = window.ePub(bookUrl)
      this.book.renderTo('area')
    },
    handleChange (val) { // 修改字体大小
      this.book.setStyle('font-size', val + 'px')
    },
    fjPath (url) { // 分解路径
      const arr = url.split('/')
      let newUrl = ''
      arr.forEach((e, i) => {
        if (i < arr.length - 2) {
          newUrl += (e + '/')
        }
      })
      return newUrl + 'probation.epub'
    },
    fjPathAll (url, hz) {
      const arr = url.split('/')
      let newUrl = ''
      arr.forEach((e, i) => {
        if (i < arr.length - 1) {
          newUrl += (e + '/')
        }
      })
      return newUrl + 'temp/book/book.' + hz
    },
    updateUserReadrate (rate, schedule) {
      const obj = this.$route.query
      let par = {
        userId: this.$store.state.userMsg.id,
        bookId: obj.bookId,
        rate: rate,
        schedule: schedule
      }
      Axios.post(this.$allUrl.updateUserReadrate, par, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          let list = res.data
          this.list = []
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.list.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              author: e.bookAuthors,
              time: e.paymentTime,
              star: e.starLevel,
              read: e.rate
            })
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    const self = this
    const obj = this.$route.query
    if (obj.bookId) {
      const userId = this.$store.state.userMsg.id
      const bookId = obj.bookId
      const par = userId ? `?bookId=${bookId}&userId=${userId}` : `?bookId=${bookId}`
      this.$get(this.$allUrl.getBookInfo + par).then(res => {
        if (res.code === '0') {
          const admin = this.$allUrl.imgAdmin
          this.bfb = Number(obj.type) === 2 ? 1000 : 10
          var url = admin + res.data.bookUrl
          if (res.data.bookType === 11) {
            this.loading = false
            this.bookType = 11
            // this.pdfUrl = '/static/pdf/web/viewer.html?file=' + this.fjPathAll(url, 'pdf')
            // 'http://192.168.1.142:8080/YSBookMall/sign/userbase/pdf'
            // this.$allUrl.getpdf
            Axios.post(this.$allUrl.getpdf, {
              filePath: this.fjPathAll(res.data.bookUrl, 'pdf'),
              proportion: 10
            }, {
              transformRequest: [function (data) {
                let ret = ''
                for (let it in data) {
                  ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
              }],
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(res => {
              if (res.path) {
                let aUrl = admin + res.path
                this.pdfUrl = '/static/pdf/web/viewer.html?file=' + aUrl
              }
            }).catch(err => {
              console.log(err)
            })
          } else if (res.data.bookType === 13) {
            this.bookType = 13
            this.audiomp3 = this.fjPathAll(url, 'mp3')
          } else if (res.data.bookType === 14) {
            this.bookType = 14
            this.videomp4 = this.fjPathAll(url, 'mp4')
          } else {
            this.bookType = 12
            this.getBook(this.fjPathAll(url, 'epub'))
            this.getToc()
            this.getPages()
            if (obj.jd) {
              self.aa = obj.jd
              self.width = Number(obj.bfb) + '%'
              self.book.goto(self.aa)
            }
            this.book.on('book:pageChanged', function (location) {
              self.width = location.percentage * 100 + '%'
              self.rate = Number((location.percentage * 100).toFixed(2))
              if (location.percentage * 100 > self.bfb) {
                self.loading2 = true
              }
              setTimeout(function () {
                if (location.percentage * 100 > self.bfb) {
                  self.book.goto(self.aa)
                  alert('购买后读全本')
                  self.loading2 = false
                } else {
                  self.aa = self.book.currentChapter.cfi
                }
              }, 100)
            })
            this.book.on('renderer:locationChanged', function (locationCfi) {
              self.locationCfi = locationCfi
            })
          }
        }
      })
    }
  },
  watch: {
    locationCfi (val) {
      this.updateUserReadrate(this.rate, val)
    }
  }
}
</script>
<style lang="less" scoped>
  .mp4, .mp3{
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .book-div, .pdfDiv{
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: white;
    display: -moz-box;
    -moz-box-orient:vertical;
    display: -webkit-box;
    -webkit-box-orient:vertical;
    border: 0;
    .book-div{
      width: 100%;
      height: 100%;
      background: red;
    }
    .modal-div{
      position: absolute;
      background: rgba(00, 00, 00, 0.5);
      z-index: 100;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      .modal-header{
        text-align: right;
        background-color: #4D80EF;
        color: white;
        font-size: 20px;
        padding: 20px 0;
        span{
          font-size: 22px;
          font-weight: 600;
        }
        i{
          padding: 10px;
          cursor: pointer;
        }
      }
      .catalog-view{
        width: 300px;
        height: 100%;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        background: white;
        .catalog-tree{
          flex: 1;
          overflow: auto;
        }
      }
      .setting-view{
        width: 300px;
        height: 100%;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        background: white;
        .setting-content{
          padding: 10px;
        }
      }
    }
    .book-header{
      background-color: #4D80EF;
      color: white;
      font-size: 20px;
      padding: 20px 0;
      i{
        padding: 10px;
        cursor: pointer;
      }
    }
    .book-content{
      width: 100%;
      flex: 1;
      -webkit-box-flex:1;
      -webkit-flex:1;
      overflow:auto;
      position: relative;
      .middle{
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        // background: #F9F4E9;
        .jd{
          width: 100%;
          height: 10px;
          position: absolute;
          background: white;
          .bfb{
            background: black;
            height: 100%;
            width: 0;
          }
        }
        .prev, .next{
          font-size: 40px;
          vertical-align: middle;
          // text-align: center;
          align-items:center;
          display: flex;
          padding: 0 30px;
          i{
            cursor: pointer;
          }
        }
        .area{
          flex: 1;
          overflow: hidden;
          padding: 20px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/book/book.vue